// Formatação dos campos do atestado compartilhada entre a listagem web e a mobile.

const EMPTY = '—';

const attestedTypeLabels = {
  REPOUSO: 'Repouso',
  COMPARECIMENTO: 'Comparecimento',
};

export const formatAttestedType = (attested) => {
  const rawType = attested.tipoDeAtestadoValue ?? attested.tipoDeAtestado;
  return attestedTypeLabels[rawType] ?? attested.tipoDeAtestado ?? EMPTY;
};

export const isRestType = (attested) =>
  (attested.tipoDeAtestadoValue ?? attested.tipoDeAtestado) === 'REPOUSO';

export const formatDaysOfRest = (attested) => {
  if (!isRestType(attested)) return EMPTY;
  const days = attested.quantidadeDeDiasDeRepouso;
  if (days == null || days === 0) return EMPTY;
  return `${days} dia(s)`;
};

export const formatPeriod = (attested) => {
  const { horaInicial, horaFinal } = attested;
  if (!horaInicial && !horaFinal) return EMPTY;
  return `${horaInicial ?? EMPTY} às ${horaFinal ?? EMPTY}`;
};

// O CID pode chegar como texto (formato antigo) ou como objeto do catálogo.
export const formatCid = (attested) => {
  const { cid } = attested;
  if (!cid) return EMPTY;
  if (typeof cid === 'object') {
    return [cid.code, cid.description].filter(Boolean).join(' - ') || EMPTY;
  }
  return cid;
};

export const formatText = (value) => value ?? EMPTY;
